import React, {Component} from "react"
import {connect} from "react-redux"
import {translate} from "react-i18next"

import {Container, Row, Col} from "../Grid"
import ScrollButton from "../ScrollButton"
import Menu from "../Menu"

import styles from "./styles.css"

import mbtml_logo from "../../assets/icons/logo-mbtml.svg"

class Footer extends Component {
  render() {
    const {footer_menu, t} = this.props

    return (
      <footer className={styles.Footer}>
        <div className="footer-top">
          <Container>
            <Row>
              <Col className="footer-mbtml" size={12}>
                <div className="inner">
                  <img src={mbtml_logo} alt="abat+ Lernplattform" />
                  <p
                    dangerouslySetInnerHTML={{
                      __html: t(
                        "abat+ Lernplattform –<br>Lernen und Wissen neu definiert!"
                      )
                    }}
                  />
                </div>
              </Col>
            </Row>
          </Container>
        </div>
        <div className="footer-bottom">
          <Container>
            <Row>
              <Col className="footer-copyright" lg={5}>
                <p>
                  &copy; {new Date().getFullYear()}{" "}
                  {t(
                    "abat+ GmbH. Alle Rechte vorbehalten."
                  )}
                </p>
              </Col>
              <Col className="footer-nav-extra" lg={5}>
                <Menu items={footer_menu} />
              </Col>
              <Col className="footer-to-top" lg={1}>
                <ScrollButton
                  target="#root"
                  duration="1000"
                  icon="icon-arrow-up"
                />
              </Col>
            </Row>
          </Container>
        </div>
      </footer>
    )
  }
}

const mapStateToProps = state => {
  return {
    lang: state.app.lang
  }
}

// export default Footer
Footer = connect(mapStateToProps)(Footer)
export default translate()(Footer)



// WEBPACK FOOTER //
// ./src/components/Footer/index.js